<div class="wrap">
  <img 
    class="user-avatar"
    [hidden]="!value || loading" 
    [src]="value"
    (load)="imageLoaded()"
    alt="demo-avatar"
  />
  <img 
    class="user-avatar" 
    [hidden]="value || loading"
    src="https://www.pphfoundation.ca/wp-content/uploads/2018/05/default-avatar.png" 
    (load)="imageLoaded()"
    alt="demo-avatar"
  />
  <div *ngIf="loading" class="avatar-spinner-wrap">
    <mat-progress-spinner  
      mode="indeterminate" 
      diameter="30">
    </mat-progress-spinner>
  </div>
  <button class="bciti-button upload-button" (click)="openDialog()">{{ label }}</button>
</div>
